// Package Imports
import { useEffect } from 'react'
import { useRouter } from '@tanstack/react-router'

// Core Imports
import { authEvents } from '@/core/lib/auth-events'
import { signOut } from '@/core/utils/auth-utils'
import { ROUTES } from '@/core/constants/routes'

const AuthEventsBinder = () => {
  const router = useRouter()

  useEffect(() => {
    const offSignedOut = authEvents.on('signed-out', async () => {
      await signOut()
      router.navigate({ to: '/', search: { status: 'signedOut' } })
    })
    const offForbidden = authEvents.on('forbidden', () => {
      router.navigate({ to: ROUTES.forbidden })
    })
    return () => {
      offSignedOut()
      offForbidden()
    }
  }, [router])

  return null
}

export default AuthEventsBinder
